import React from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePaginationBar from './common/TablePaginationBar';
import { useTablePagination } from '../hooks';

function TableView(props) {

    const { query_results } = props;

    // Los resultados de una consulta pueden ser cientos de filas dentro de
    // una burbuja del chat. Se pagina con tamaño configurable (10/20/50);
    // `resetDeps` vuelve a la primera página cuando llega otro resultado.
    const { page, rowsPerPage, pageRows, paginationProps } = useTablePagination(query_results, {
        storageKey: 'chatQueryResults',
        resetDeps: [query_results]
    });

    return (
        <>
        <TableContainer sx={{ border: 0, width: "100%" ,backgroundColor: "var(--wb-x-bg-17242c, #17242cff)"}}>
        <Table sx={{ border: 0, boxShadow: 'var(--wb-x-shadow-0000000d, rgba(0, 0, 0, 0.05)) 0px 4px 12px',
                    borderTopRightRadius: 16, borderTopLeftRadius: 16, width: "100%"
            }}
            aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ color: "var(--wb-x-text-cfcfcf, #cfcfcf)", fontWeight: "bold" }}></TableCell>
                        { Object.entries(query_results[0]).map((t,k) => <TableCell key={"row_cell_head_"+k} sx={{ p:1, pr:2,color: "var(--wb-x-text-cecaca, #cecacaff)", fontWeight: "bold"  }} align={ (typeof(t[1])=='number') ? "right": "left" }>{t[0]}</TableCell>) }
                    </TableRow>
                </TableHead>

                <TableBody>
                {pageRows.map((row,x) => (
                    <TableRow
                    key={'row'+(page*rowsPerPage+x)}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        {/* Numeración continua a través de las páginas, no 1..N por página */}
                        <TableCell sx={{ p: 1, m: 0, color: "var(--wb-x-text-cccccc, #ccc)" }} align="right">{page*rowsPerPage+x+1}</TableCell>
                        { Object.entries(row).map((t,k) => <TableCell key={"row_cell_"+x+"_"+k} sx={{ p:1, pr:2, m:0,color: "var(--wb-x-text-c2c2c2, #c2c2c2ff)" }} component={ (k===0) ? "th": "" } scope={ (k===0) ? "row": "" } align={ (typeof(t[1])==='number') ? "right": "left" }>{t[1]}</TableCell>) }
                    </TableRow>

                ))}
                </TableBody>
            </Table>
        </TableContainer>
        <TablePaginationBar {...paginationProps} />
        </>
    );
}

export default TableView;
